import flatten from 'lodash-es/flatten'

import type { GetInstalledThemesResponse, InstalledTheme, LibraryTheme } from './types'

const mapTheme = (
  theme: GetInstalledThemesResponse['themes'][number],
  status?: string,
  selectedThemeId?: string,
) => ({
  id: theme.id,
  preset: theme.preset,
  handle: theme.themeLibrary.handle,
  version: theme.themeLibrary.version,
  name: theme.name,
  status,
  role: theme.role,
  tags: theme.themeLibrary?.version ? [`version ${theme.themeLibrary.version}`] : undefined,
  image: theme.screenshots?.desktopUrl,
  previewUrl: theme.previewUrl,
  updatedAt: theme.settingsUpdatedAt || theme.updatedAt,
  isMain: theme.role === 'main',
  isActive: theme.id === selectedThemeId,
  isProcessing: theme.status === 'Duplicating' || theme.status === 'Installing',
  isCustomized: theme.customisation === 'Fully',
})

export const getThemeList = (
  currentTheme?: GetInstalledThemesResponse['themes'][number],
  availableThemes?: GetInstalledThemesResponse['themes'],
  selectedThemeId?: string,
): InstalledTheme[] => {
  const getStatus = (theme: GetInstalledThemesResponse['themes'][number]) => {
    const status =
      theme.status === 'Installing' || theme.status === 'Duplicating' ? theme.status : undefined

    if (!status) return undefined

    return `${status}...`
  }

  return [
    currentTheme ? mapTheme(currentTheme, undefined, selectedThemeId) : undefined,
    ...(availableThemes?.map((theme) => mapTheme(theme, getStatus(theme), selectedThemeId)) || []),
  ].filter(Boolean) as InstalledTheme[]
}

export const getPresetImages = (libraryThemes: LibraryTheme[]) =>
  libraryThemes.reduce<string[]>((imagesList, theme) => {
    const presetImages = theme.versions![0].presets
      ? theme.versions![0].presets.map((preset) => {
          return [preset.screenshots?.desktopUrl, preset.screenshots?.mobileUrl].filter(
            (item) => !!item,
          ) as string[]
        })
      : []

    return [...imagesList, ...flatten(presetImages)]
  }, [])
